import { onBeforeUnmount, onMounted } from 'vue'

/** Тап по этим элементам фокус не снимает: у них своя реакция на касание. */
const INTERACTIVE =
  'input, textarea, select, label, button, a, [role="button"], [contenteditable="true"]'

/** Гасим клавиатуру только от полей ввода — кнопке фокус сбрасывать незачем. */
const FIELDS = 'input, textarea, [contenteditable="true"]'

/**
 * Тап мимо поля закрывает клавиатуру. В Telegram на iOS она сама не прячется:
 * WKWebView не снимает фокус по касанию неинтерактивного места, и клавиатура
 * висит, пока не нажмёшь «Готово» на ней самой.
 *
 * Слушаем `pointerdown`, а не `click`: click WKWebView доставляет только на
 * элементы, которые считает кликабельными, — по обычному `div` он не придёт.
 * Поэтому и оборачивать приложение в `button` не нужно.
 */
export function useKeyboardDismiss(): void {
  function dismiss(event: Event): void {
    const target = event.target
    /*
     * Тап по кнопке пропускаем намеренно: снятый фокус прячет клавиатуру,
     * вёрстка тут же уезжает вверх, и click уходит уже мимо кнопки.
     */
    if (!(target instanceof Element) || target.closest(INTERACTIVE)) return

    const active = document.activeElement
    if (active instanceof HTMLElement && active.matches(FIELDS)) active.blur()
  }

  onMounted(() => {
    document.addEventListener('pointerdown', dismiss)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('pointerdown', dismiss)
  })
}
